(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("electron"), require("events"));
	else if(typeof define === 'function' && define.amd)
		define(["electron", "events"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("electron"), require("events")) : factory(root["electron"], root["events"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_24__, __WEBPACK_EXTERNAL_MODULE_258__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition